import type { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form/dist/types';

export const getError = (
  formError: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined,
  errorMessage: string,
) => (formError ? errorMessage : '');
